import * as React from "react";
import parse from "html-react-parser";
import { Banner } from "@glamcorner/components/lib/core/components/Banner";
import "./catalogue-header.scss";

interface CatalogueHeaderProps {
  count: number;
  title?: string;
  shortDescription?: string;
}

export const CatalogueHeader: React.FC<CatalogueHeaderProps> = ({ count, title, shortDescription }) => {
  return (
    <div className="category-header-and-description c-catalogue__header">
      <div className="js-catalog-header t-catalog-header">
        <Banner
          className="c-catalogue-header__banner"
          size="lg"
          heading={title || "Hire Designer Dresses"}
          subHeading={`(${count} items)`}
        />
        {shortDescription && <div className="c-catalog-short-description">{parse(shortDescription)}</div>}
      </div>
    </div>
  );
};
